type ArcVaultPage = "wpds-builder" | "dashboard" | "qualifications" | "eligibility" | "procedures" | "projects" | "ncrs" | "inspections" | "audit";
type NavIconName = "dashboard" | "qualifications" | "eligibility" | "builder" | "procedures" | "projects" | "inspections" | "ncrs" | "audit";

const navigationGroups: { heading: string; items: { page: ArcVaultPage; label: string; icon: NavIconName }[] }[] = [
  { heading: "OVERVIEW", items: [
    { page: "dashboard", label: "Dashboard", icon: "dashboard" },
  ] },
  { heading: "WELDING", items: [
    { page: "qualifications", label: "Welder Qualifications", icon: "qualifications" },
    { page: "eligibility", label: "Welder / WPDS Check", icon: "eligibility" },
    { page: "wpds-builder", label: "WPDS Builder", icon: "builder" },
    { page: "procedures", label: "WPS / WPDS Library", icon: "procedures" },
  ] },
  { heading: "QUALITY & COMPLIANCE", items: [
    { page: "projects", label: "Projects", icon: "projects" },
    { page: "inspections", label: "Inspection & Testing", icon: "inspections" },
    { page: "ncrs", label: "Non-Conformance Reports", icon: "ncrs" },
    { page: "audit", label: "Audit", icon: "audit" },
  ] },
];

function NavigationIcon({ name }: { name: NavIconName }) {
  const drawing = (() => {
    switch (name) {
      case "dashboard": return <><rect x="3" y="3" width="7" height="7" rx="1.2" /><rect x="14" y="3" width="7" height="7" rx="1.2" /><rect x="3" y="14" width="7" height="7" rx="1.2" /><rect x="14" y="14" width="7" height="7" rx="1.2" /></>;
      case "qualifications": return <><circle cx="12" cy="8" r="3.2" /><path d="M5 20v-2a7 7 0 0 1 14 0v2" /></>;
      case "eligibility": return <><circle cx="10.5" cy="10.5" r="7" /><path d="m16 16 5 5M7.5 10.5l2 2 4-4" /></>;
      case "builder": return <><path d="m4 17 11.6-11.6 3 3L7 20H4v-3Z" /><path d="m13.7 7.3 3 3M4 5h5M4 9V5M15 20h5v-5" /></>;
      case "procedures": return <><path d="M7 3h9l4 4v14H7zM16 3v5h4M10 12h7M10 16h7M4 7v14" /></>;
      case "projects": return <><path d="M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M3 10h18" /></>;
      case "inspections": return <><rect x="5" y="4" width="14" height="17" rx="2" /><path d="M9 4.5h6M9 13l2 2 4-4" /></>;
      case "ncrs": return <><path d="M10.3 4.2 2.5 18a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0Z" /><path d="M12 9v5M12 18h.01" /></>;
      case "audit": return <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M7 3v4M17 3v4M3 10h18M8 15l2.5 2.5L16 13" /></>;
    }
  })();

  return <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{drawing}</svg>;
}

export default function SidebarNavigation({ page, onNavigate }: { page: ArcVaultPage; onNavigate: (next: ArcVaultPage) => void }) {
  return <nav className="arc-sidebar-nav" aria-label="Main navigation">
    {navigationGroups.map(group => <div className="arc-nav-group" key={group.heading}>
      <div className="arc-nav-heading">{group.heading}</div>
      {group.items.map(item => <button
        type="button"
        key={item.page}
        className={"arc-nav-link" + (page === item.page ? " selected" : "")}
        aria-current={page === item.page ? "page" : undefined}
        onClick={() => onNavigate(item.page)}
      >
        <span className="arc-nav-icon"><NavigationIcon name={item.icon} /></span>
        <span className="arc-nav-label">{item.label}</span>
      </button>)}
    </div>)}
  </nav>;
}
